import { render, staticRenderFns } from "./ModuleV3.vue?vue&type=template&id=b098400c&scoped=true&"
import script from "./ModuleV3.vue?vue&type=script&lang=js&"
export * from "./ModuleV3.vue?vue&type=script&lang=js&"
import style0 from "./ModuleV3.vue?vue&type=style&index=0&id=b098400c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b098400c",
  null
  
)

export default component.exports